var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 3.75H3C2.83424 3.75 2.67527 3.81585 2.55806 3.93306C2.44085 4.05027 2.375 4.20924 2.375 4.375V15C2.375 15.3315 2.5067 15.6495 2.74112 15.8839C2.97554 16.1183 3.29348 16.25 3.625 16.25H17.375C17.7065 16.25 18.0245 16.1183 18.2589 15.8839C18.4933 15.6495 18.625 15.3315 18.625 15V4.375C18.625 4.20924 18.5592 4.05027 18.4419 3.93306C18.3247 3.81585 18.1658 3.75 18 3.75ZM17.375 15H3.625V5.79609L10.0773 11.7109C10.1926 11.8168 10.3435 11.8755 10.5 11.8755C10.6565 11.8755 10.8074 11.8168 10.9227 11.7109L17.375 5.79609V15Z",
    fill: "#14142B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.8c56e04c1f744bfbd2fdde1776db1cd7.svg";
export { ForwardRef as ReactComponent };